export default __webpack_public_path__ + "static/media/mintbanner.19f37861.png";